import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Voltage from "../axes/Voltage";

let ConnectionMinVoltage = {
    type: "line",
    label: "Connection min Voltage",
    fill: false,
    lineTension: 0,
    colorPalette: 6,
    borderWidth:1,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Voltage,
    xAxis:Time
};

export default ConnectionMinVoltage;



// WEBPACK FOOTER //
// ./src/components/chart/channels/ConnectionMinVoltage.js